/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_DurationInputs */

const en_us2_workout_after_duration = /** @type {(inputs: Workout_After_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`And the length?`)
};

const pt_br2_workout_after_duration = /** @type {(inputs: Workout_After_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E a duração?`)
};

const es_419_workout_after_duration = /** @type {(inputs: Workout_After_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Y la duración?`)
};

const pt_pt2_workout_after_duration = /** @type {(inputs: Workout_After_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E a duração?`)
};

const fr_fr2_workout_after_duration = /** @type {(inputs: Workout_After_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et la durée ?`)
};

const de_de2_workout_after_duration = /** @type {(inputs: Workout_After_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Und die Dauer?`)
};

const it_it2_workout_after_duration = /** @type {(inputs: Workout_After_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E la durata?`)
};

/**
* | output |
* | --- |
* | "And the length?" |
*
* @param {Workout_After_DurationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_duration = /** @type {((inputs?: Workout_After_DurationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_DurationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_duration(inputs)
	if (locale === "es-419") return es_419_workout_after_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_duration(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_duration(inputs)
	if (locale === "de-DE") return de_de2_workout_after_duration(inputs)
	if (locale === "it-IT") return it_it2_workout_after_duration(inputs)
	return en_us2_workout_after_duration(inputs)
});
export { workout_after_duration as "workout-after.duration" }